module.exports={
	"Form": "RoleEdgeViewManifest",
	"Scope": "RoleEdge-View",
	"Descriptors":
	{
		"RoleEdgeDetails.IDRoleEdge":
		{
			"Name": "ID",
			"Hash": "RoleEdgeView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "RoleEdgeIdentity",
				"Group": "RoleEdgeIdentity"
			}
		},
		"RoleEdgeDetails.GUIDRoleEdge":
		{
			"Name": "GUID",
			"Hash": "RoleEdgeView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "RoleEdgeIdentity",
				"Group": "RoleEdgeIdentity"
			}
		},
		"RoleEdgeDetails.ParentIDRole":
		{
			"Name": "Parent Role ID",
			"Hash": "RoleEdgeView-ParentIDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 3,
				"Section": "RoleEdgeIdentity",
				"Group": "RoleEdgeIdentity"
			}
		},
		"RoleEdgeDetails.ChildIDRole":
		{
			"Name": "Child Role ID",
			"Hash": "RoleEdgeView-ChildIDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 3,
				"Section": "RoleEdgeIdentity",
				"Group": "RoleEdgeIdentity"
			}
		},
		"RoleEdgeDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "RoleEdgeView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "RoleEdgeAudit",
				"Group": "RoleEdgeAudit"
			}
		},
		"RoleEdgeDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "RoleEdgeView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "RoleEdgeAudit",
				"Group": "RoleEdgeAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Role Hierarchy",
			"Hash": "RoleEdgeIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Role Hierarchy",
					"Hash": "RoleEdgeIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "RoleEdgeAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "RoleEdgeAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
